export * from './mapVariables';
